module.exports = __webpack_public_path__ + "img/background-light.ff5cf412.png";